const queryString = (directive, ...args) => `[:d = ${directive}(${args.join(', ')})]`

export default {
  has: (type, field) => queryString('has', `my.${type}.${field}`),
  missing: (type, field) => queryString('missing', `my.${type}.${field}`),
  similar: (id, precision) => queryString('similar', `"${id}"`, precision),
  at: {
    id: id => queryString('at', 'document.id', `"${id}"`),
    uid: (type, uid) => queryString('at', `my.${type}.uid`, `"${uid}"`),
    type: type => queryString('at', 'document.type', `"${type}"`),
    tags: tags => queryString('at', 'document.tags', JSON.stringify(tags)),
    field: (type, field, value) => queryString('at', `my.${type}.${field}`, `"${value}"`)
  },

  in: {
    id: ids => queryString('in', 'document.id', JSON.stringify(ids)),
    uid: (type, uids) => queryString('in', `my.${type}.uid`, JSON.stringify(uids))
  },

  any: {
    id: ids => queryString('any', 'document.id', JSON.stringify(ids)),
    uid: (type, uids) => queryString('any', `my.${type}.uid`, JSON.stringify(uids)),
    type: types => queryString('any', 'document.type', JSON.stringify(types)),
    tags: tags => queryString('any', 'document.tags', JSON.stringify(tags)),
    field: (type, field, values) => queryString('any', `my.${type}.${field}`, JSON.stringify(values))
  },

  not: {
    id: id => queryString('not', 'document.id', `"${id}"`),
    uid: (type, uid) => queryString('not', `my.${type}.uid`, `"${uid}"`),
    type: type => queryString('not', 'document.type', `"${type}"`),
    tags: tag => queryString('not', 'document.tags', `"${tag}"`),
    field: (type, field, value) => queryString('not', `my.${type}.${field}`, `"${value}"`)
  },

  search: {
    doc: search => queryString('fulltext', 'document', `"${search.join(' ')}"`),
    field: (type, field, search) => queryString('fulltext', `my.${type}.${field}`, `"${search.join(' ')}"`)
  },

  date: {
    before: (type, field, date) => queryString('date.before', `my.${type}.${field}`, date.valueOf()),
    after: (type, field, date) => queryString('date.after', `my.${type}.${field}`, date.valueOf()),
    between: (type, field, start, end) => queryString('date.between', `my.${type}.${field}`, start.valueOf(), end.valueOf()),
    published: {
      before: date => queryString('date.before', 'document.first_publication_date', date.valueOf()),
      after: date => queryString('date.after', 'document.first_publication_date', date.valueOf()),
      between: (start, end) => queryString('date.between', 'document.first_publication_date', start.valueOf(), end.valueOf())
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/utils/directives.js